import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '@shared/services/alert.service';

/**
 * Interceptor para capturar erros das requisições HTTP e exibir
 * mensagens vindas do backend através do AlertService.
*/
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const TOKEN_EXPIRED_CODE = 401;
    const skipAlerts = req.headers.has('X-Skip-Alerts');

    if (skipAlerts) {
        req = req.clone({ headers: req.headers.delete('X-Skip-Alerts') });
    }

    const alertService = inject(AlertService);

    return next(req).pipe(
        catchError((error) => {
            if (skipAlerts || error.status === TOKEN_EXPIRED_CODE) {
                return throwError(() => error);
            }

            const body = error.error;

            // Mensagens de validação por campo (ex.: { validacao: [{ mensagem }] } ou string[]).
            const validacao: unknown = body?.validacao;
            const validacaoMsgs = Array.isArray(validacao)
                ? validacao
                    .map((v: any) => (typeof v === 'string' ? v : v?.mensagem ?? v?.detalhe))
                    .filter(Boolean)
                : [];

            // Ordem de preferência: validação detalhada → detalhes → mensagem → título → fallback.
            const errorMessage =
                (validacaoMsgs.length ? validacaoMsgs.join(' ') : null) ||
                body?.detalhes ||
                body?.mensagem ||
                body?.titulo ||
                'Ocorreu um erro inesperado.';

            alertService.showErrorMessage(errorMessage);

            return throwError(() => error);
        })
    );
};
